var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "prompt-weight" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Prompt Weight"))),
      ]),
      _vm._v(" "),
      _vm.projectName === "Img2Go"
        ? _c(
            "span",
            {
              staticClass: "badge badge-starter",
              on: { click: _vm.handleProOrChange },
            },
            [_vm._v(_vm._s(_vm._f("trans")("STARTER")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.projectName !== "Img2Go"
        ? _c(
            "span",
            {
              staticClass: "badge badge-warning",
              on: { click: _vm.handleProOrChange },
            },
            [_vm._v(_vm._s(_vm._f("trans")("PREMIUM")))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "text-white" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm._f("trans")(
              "Adjust the prompt weight to fine-tune how much your input impacts the resulting image. Increase the prompt weight for a stronger influence."
            )
          ) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "slider" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.creatorStudio.settings.conversion.options.cfg_scale,
            expression: "creatorStudio.settings.conversion.options.cfg_scale",
            modifiers: { number: true },
          },
        ],
        staticClass: "form-control-range range-slider",
        class: { disabled: _vm.isFreeUser },
        attrs: { type: "range", id: "formControlRange", min: "0", max: "20" },
        domProps: {
          value: _vm.creatorStudio.settings.conversion.options.cfg_scale,
        },
        on: {
          change: _vm.handleProOrChange,
          __r: function ($event) {
            _vm.$set(
              _vm.creatorStudio.settings.conversion.options,
              "cfg_scale",
              _vm._n($event.target.value)
            )
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "slider-points" }, [
      _c("p", [_vm._v("0%")]),
      _vm._v(" "),
      _c("p", [_vm._v("50%")]),
      _vm._v(" "),
      _c("p", [_vm._v("100%")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }